export default __webpack_public_path__ + "static/media/IVEX_logo.e1f5700d.png";